import { type TemplateDescriptor, logoUrl } from '@smart-link/shared';
import { BgImageUpload } from './BgImageUpload';
import { Input } from './ui/input';

/** logo 字段在不同模板下的 label/placeholder（bgUpload 模板复用字段：logo=背景图、appName=按钮文字）。 */
export const logoFieldLabel = (tpl?: TemplateDescriptor) =>
  tpl?.bgUpload ? '背景图' : '应用 Logo (R2 相对路径)';
export const appNameLabel = (tpl?: TemplateDescriptor) =>
  tpl?.bgUpload ? '按钮文字' : `应用名称${tpl?.appNameHint ?? ''}`;
export const appNamePlaceholder = (tpl?: TemplateDescriptor) =>
  tpl?.bgUpload ? 'Continue' : 'App Store';

/**
 * logo 字段主体（创建/编辑表单共用）：bgUpload 模板渲染背景图上传控件，
 * 其余模板渲染「缩略预览 + R2 相对路径输入」。
 */
export function LogoField({
  tpl,
  value,
  onChange,
  inputId,
}: {
  tpl: TemplateDescriptor | undefined;
  value: string;
  onChange: (v: string) => void;
  inputId?: string;
}) {
  if (tpl?.bgUpload) return <BgImageUpload value={value} onChange={onChange} />;
  const url = logoUrl(value);
  return (
    <div className="flex items-center gap-3">
      {url ? (
        <img
          src={url}
          alt="logo 预览"
          className="ring-border size-10 shrink-0 rounded-lg object-cover ring-1"
        />
      ) : (
        <div className="bg-muted text-muted-foreground flex size-10 shrink-0 items-center justify-center rounded-lg text-[10px]">
          无
        </div>
      )}
      <Input
        id={inputId}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="202508/07/xxx.png"
      />
    </div>
  );
}
